import { Directive, forwardRef } from '@angular/core';
import { Validator, AbstractControl, ValidationErrors, NG_VALIDATORS } from '@angular/forms';

@Directive({
    selector: '[appValidDate]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => ValidDateDirective), multi: true }
    ]
})
export class ValidDateDirective implements Validator {

    validate(c: AbstractControl): ValidationErrors {
        if (c.value === undefined || c.value === null || c.value === '') {
            return null;
        }

        const value = c.value;

        if (!/^\d{1,2}-\d{1,2}-\d{4}$/.test(value)) {
            return {
                invalidDate: true
            };
        }

        const parts = value.split('-');

        const month = Number(parts[0]);
        const day = Number(parts[1]);
        const year = Number(parts[2]);

        const date = new Date(year, month - 1, day); // Month -1 because javascript...

        const actualDay = date.getDate();
        const actualMonth = date.getMonth() + 1; // haHaa, javascript...
        const actualYear = date.getFullYear();

        // If the supplied parts match the parts we grab from the Date object that parsed our strings, we have a valid date!
        const valid = day === actualDay && month === actualMonth && year === actualYear;

        // Minimum value supported: 01/01/1753 00:00:00".
        let minimal = new Date(1753, 1, 1);
        if (minimal > date) {
            return {
                minimalDate: true
            }
        }

        if (!valid) {
            return {
                invalidDate: true
            };
        }

        return null;
    }
}
